import { Navigate, useParams } from "react-router-dom";

/**
 * Legacy route shim: profiles moved from /roster/:username to /profile/:username.
 * Keeps old links (bookmarks, emails) working.
 */
export function RosterProfileRedirect() {
  const { username } = useParams<{ username: string }>();

  if (!username) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`/profile/${username}`} replace />;
}
